<template>
  <div class="row">
    <div class="col-12">
      <div class="card card-body">
        <div class="col-12 table-responsive">
          <table class="table table-hover table-sm table-bordered">
            <thead>
              <th>
                المستخدم
              </th>
              <th>
                الجهاز
              </th>
              <th>
                الحالة
              </th>
              <th>
                تاريخ الاضافة
              </th>
            </thead>
            <tbody>
              <tr v-for="device in devices" :key="device._id">
                <td>
                  {{ device.name }}
                </td>
                <td>
                  <img :src="require('@/assets/images/meta.png')" style="width: 32px" v-if="device.meta">
                  <img :src="require('@/assets/images/qr-code.png')" style="width: 32px" v-if="!device.meta">
                  {{ device.title }}
                  <br>
                  {{ device.phone }}
                </td>
                <td>
                  <span class="btn btn-sm btn-success" v-if="device.status == 1">متصل</span>
                  <span class="btn btn-sm btn-danger" v-if="device.status == 2">قطع الاتصال</span>
                  <span class="btn btn-sm btn-warning" v-if="device.status == 0">في الانتظار</span>

                  <ul v-if="device.meta">
                    <li>
                      حالة الربط: 
                      <span v-if="device.confirm_status == 1" class="text-success"><i class="fa fa-check"></i> تم</span>
                      <span v-if="device.confirm_status != 1" class="text-warning"><i class="fa fa-clock-o"></i> في الإنتظار</span>
                    </li>
                    <li>
                      حالة الإتصال: 
                      <span v-if="device.link_status == 1 && device.confirm_status == 1" class="text-success"><i class="fa fa-check"></i> تم</span>
                      <span v-if="device.link_status != 1 " class="text-warning"><i class="fa fa-clock-o"></i> في الإنتظار</span>
                    </li>
                  </ul>
                  
                </td>
                <td>
                  {{ device.add_date.replace('T', ' ').split(".")[0] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      user: JSON.parse(localStorage.getItem('user')),
      devices: []
    }
  },
  created(){
    var g = this;
    $.post(api + '/admin/devices', {
        jwt: this.user.jwt
    }).then(function(r){
        g.loading = false
        if(r.status != 100){
            alert(r.response)
        }else{
            g.devices = r.response
        }
    }).fail(function(){
        g.loading = false
    })
  },
  methods: {
  }
}
</script>

<style>

</style>